import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { useLanguage } from '@/contexts/LanguageContext'

interface GuestRouteProps {
  children: React.ReactNode
}

export default function GuestRoute({ children }: GuestRouteProps) {
  const { isAuthenticated } = useAuth()
  const { language } = useLanguage()

  if (isAuthenticated()) {
    return <Navigate to={`/${language}/tool-management`} replace />
  }

  return <>{children}</>
}
